import React from 'react';
import { connect } from 'react-redux';
import { dateTime } from '../../../utils/parsing';
import { attachDefaultUnits } from '../../../redux/selectors/points';
import PointTable from '../AssetPointTable/PointTable';

const getPointRow = (buildingTz) => (p) => ({
  id: p.id,
  values: [
    p.equipName,
    `${p.name} ${p.description}`,
    p.device,
    `${p.value}`,
    p.units,
    p.areaServed,
    p.location,
    dateTime(p.lastUpdatedTs, buildingTz),
  ],
});

const SensorTypePointTable = ({ points, buildingTz }) => (
  <PointTable variant="sensorType" points={points} rowBuilder={getPointRow(buildingTz)} />
);

export default connect((state, { points }) => ({
  points: attachDefaultUnits(state, points),
}))(SensorTypePointTable);
